import { createAction, props } from '@ngrx/store';
import { ChatConversation } from '../../domain/models/chat-conversation.model';
import { ConversationSummary } from '../../domain/models/conversation-summary.model';
import { QuickQuestion } from '../../domain/models/quick-question.model';

export const setActiveConversation = createAction(
  '[Conversation] Set Active Conversation',
  props<{ activeConversation: ChatConversation | null }>(),
);

export const setConversationHistory = createAction(
  '[Conversation] Set Conversation History',
  props<{ conversationHistory: readonly ConversationSummary[] }>(),
);

export const setSavedConversations = createAction(
  '[Conversation] Set Saved Conversations',
  props<{ savedConversations: readonly ConversationSummary[] }>(),
);

export const setSelectedConversationId = createAction(
  '[Conversation] Set Selected Conversation Id',
  props<{ selectedConversationId: string | null }>(),
);

export const setQuickQuestions = createAction(
  '[Conversation] Set Quick Questions',
  props<{ quickQuestions: readonly QuickQuestion[] }>(),
);

export const setLoading = createAction('[Conversation] Set Loading', props<{ loading: boolean }>());

export const setSendingMessage = createAction(
  '[Conversation] Set Sending Message',
  props<{ sendingMessage: boolean }>(),
);

export const setError = createAction('[Conversation] Set Error', props<{ error: string | null }>());

export const initializeConversationState = createAction('[Conversation] Initialize State');

export const resetConversationState = createAction('[Conversation] Reset State');
